import { useNavigate } from "react-router-dom";
import { VertualCard } from "./../../Public/assets";
import React from "react";
import { ArrowRight } from "lucide-react";

function EmbeddedBanking() {
  const navigate = useNavigate();
  return (
    // md:mx-[84px] lg:mx-0
    <div className="bg-gradientGreen rounded-[15px]  flex flex-col md:flex-row items-center mx-6 my-[20px] xl:mx-[134px] pt-[14.13px] md:py-[40px] lg:pt-[50px] pb-[21.77px] lg:pb-[75px] mb-14 md:mb-18 lg:mb-48 relative mt-[40px] md:mt-18 xxl:mt-[180px]">
      <div className="w-[50%] md:hidden ">
        <img
          src={VertualCard}
          alt="virtualcard"
          className="   w-[184px] h-[217px] mx-auto md:w-auto"
        />
      </div>

      <div className="flex  flex-col items-center md:items-start sm:w-[50%] lg:min-h-[92px] md:w-full  pl-[13.57px] md-[50%] lg:pl-12 mt-[20px] md:mt-0">
        <h1 className="font-IvyJournal font-semibold text-[32px] md:text-[40px] md:leading-[44px] lg:text-[52px] lg:leading-[63.17px] text-dark md:text-center lg:text-start">
          Ready. Set. Go.
        </h1>
        <h3 className="mt-[19px]  text-center  max-w-[85%] text-[#162542] md:mt-2.5 text-[14px]  font-geomanistRegular font-normal md:text-[5.09px] leading-[21px]sm:leading-[5.97px] md:text-lg md:leading-[20.93px] md:text-center lg:text-start">
          Set-up your account and start saving globally now
        </h3>
        <div className="mt-[16px] md:mt-5 md:flex justify-center lg:justify-start">
          <button
            className="group relative text-[11px] md:text-xl lg:text-xl font-normal leading-[12px] md:leading-6 font- text-white rounded-[5px] bg-blueish py-2.5 xxl:py-3 px-[13px] xxl:px-5 flex items-center overflow-hidden transition-all duration-700 ease-in-out hover:px-7 max-w-fit font-geomanistMedium"
            onClick={() => {
              navigate("/email");
            }}
          >
            Open an account
            <div className="w-0 overflow-hidden transition-all duration-500 ease-in-out group-hover:w-6 md:group-hover:w-8">
              <ArrowRight className="w-[16px] md:w-[24px] h-[16px] md:h-[24px] opacity-0 translate-x-[-10px] transition-all duration-700 ease-in-out group-hover:opacity-100 group-hover:translate-x-0 group-hover:ml-2 font-geomanistMedium" />
            </div>
          </button>
        </div>
      </div>
      <div className="w-[50%] hidden md:block">
        <img
          src={VertualCard}
          alt="virtualcard"
          className="absolute bottom-[-30px] right-[0px] md:bottom-[-25px] lg:bottom-[-70px] md:right-[48px]  md:w-auto md:h-[280px] lg:h-[460px]"
        />
      </div>
    </div>
  );
}

export default EmbeddedBanking;
